import {useState, useEffect} from 'react';

const useCarousel = (data, threshold, isInfinite = false) => {
  const [leftCursor, setLeftCursor] = useState(0);
  const [rightCursor, setRightCursor] = useState(threshold);

  const isAllowed = index => index < rightCursor && index >= leftCursor;
  const [dataList, setDataList] = useState(data.filter((_, index) => isAllowed(index)));

  const isLeftCursorActive = isInfinite && data.length > threshold ? true : leftCursor > 0;
  const isRightCursorActive =
    isInfinite && data.length > threshold ? true : rightCursor <= data.length - 1;

  const reset = () => {
    setLeftCursor(0);
    setRightCursor(threshold);
  };

  const increment = () => {
    // if (!isRightCursorActive || rightCursor === data.length) {
    if (!isRightCursorActive) {
      return;
    }
    if (isInfinite && rightCursor === data.length) {
      reset();
    } else {
      setLeftCursor(leftCursor => leftCursor + 1);
      setRightCursor(rightCursor => rightCursor + 1);
    }
  };

  const decrement = () => {
    // if (!isLeftCursorActive || leftCursor === 0 || rightCursor === threshold - 1) {
    if (!isLeftCursorActive) {
      return;
    }
    let leftCursorVal = leftCursor - 1;
    let rightCursorVal = rightCursor - 1;
    if (isInfinite && leftCursor == 0) {
      leftCursorVal = data.length - threshold;
      rightCursorVal = data.length;
    }
    setLeftCursor(leftCursor => leftCursorVal);
    setRightCursor(rightCursor => rightCursorVal);
  };

  useEffect(() => {
    setDataList(data.filter((_, index) => isAllowed(index)));
  }, [leftCursor, rightCursor]);

  useEffect(() => {
    setDataList(data.filter((_, index) => isAllowed(index)));
    setLeftCursor(0);
    setRightCursor(threshold);
  }, [data]);

  return {
    dataList,
    increment,
    decrement,
    leftCursor,
    rightCursor,
    isLeftCursorActive,
    isRightCursorActive,
    reset,
  };
};

export default useCarousel;
